import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useMemo, useCallback, useEffect } from 'react';
import { useDriver } from '@/components/functional/driver/Driver/useDriver';
import { useDriverEvent } from '@/components/functional/driver/Driver/useDriverEvent';
import { useDriverStyle } from '@/components/functional/driver/Driver/useDriverStyle';
import { DriverView } from '@/components/ui/Surface/DriverView';
import { useUnmountRef } from '@/hooks/lifecycle/useUnmountRef';
import { ANIMATION_TIME_MOVING } from '@/utils/constants/ui/driver';
import { scrollTo } from '@/utils/libs/react-scroll/animateScroll';
export const Driver = (props) => {
    const { changeDriverState, driverRef, isLastInitialize, settings } = props;
    const unmountRef = useUnmountRef();
    /**
     * 対象要素にスクロール
     * @param targetIndex 対象の settings の index
     * @param duration アニメーション時間
     */
    const scrollToTarget = useCallback((targetIndex) => {
        const { ref, scrollOffset = 0 } = settings[targetIndex];
        const element = ref.current;
        if (!element) {
            return;
        }
        const { bottom, top } = element.getBoundingClientRect();
        // 対象要素が画面外かどうか判定
        const inScreen = top >= (scrollOffset || 0) && bottom <= window.innerHeight;
        // 画面外の場合 対象要素までスクロール
        if (!inScreen) {
            const { scrollTop } = document.documentElement;
            const toY = top + scrollTop - scrollOffset;
            scrollTo(toY, {
                duration: ANIMATION_TIME_MOVING,
            });
        }
    }, [settings]);
    // Driver 表示要素制御
    const { activeIndex, changeActiveIndex, isShow, reset, start, stop } = useDriver({
        isLastInitialize,
        scrollToTarget,
        unmountRef,
    });
    // Driver スタイル制御
    const { changeTransition, clipPath, hideTooltip, isShowTooltip, showTooltip, tooltipPosition, transition, updateStyle, } = useDriverStyle({
        activeIndex,
        isShow,
        settings,
    });
    // Driver イベント制御
    const { onChangeTarget, onClickOverlay } = useDriverEvent({
        activeIndex,
        changeActiveIndex,
        changeTransition,
        hideTooltip,
        scrollToTarget,
        settings,
        showTooltip,
        stop,
        unmountRef,
        updateStyle,
    });
    // 親要素でも使用できるよう Ref, state に設定
    useEffect(() => {
        driverRef.current = {
            onChangeTarget,
            reset,
            start,
            stop,
        };
        // immutable な値のみ state で管理する
        changeDriverState === null || changeDriverState === void 0 ? void 0 : changeDriverState((prevState) => {
            if ((prevState === null || prevState === void 0 ? void 0 : prevState.activeIndex) === activeIndex &&
                (prevState === null || prevState === void 0 ? void 0 : prevState.isShow) === isShow) {
                return prevState;
            }
            return { activeIndex, isShow };
        });
    }, [
        activeIndex,
        changeDriverState,
        driverRef,
        isShow,
        onChangeTarget,
        reset,
        start,
        stop,
    ]);
    const { tooltip, tooltipDisplayPosition } = useMemo(() => ({
        tooltip: settings[activeIndex].tooltip,
        tooltipDisplayPosition: settings[activeIndex].tooltipDisplayPosition,
    }), [settings, activeIndex]);
    return (_jsx(DriverView, { clipPath: clipPath, isShow: isShow, isShowTooltip: isShowTooltip, onClick: onClickOverlay, tooltip: tooltip, tooltipDisplayPosition: tooltipDisplayPosition, tooltipPosition: tooltipPosition, transition: transition }));
};
